import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyForm } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';


@Component({
  selector: 'cosmos-dynamic-form-v2',
  imports: [
    TranslatePipe, FormlyForm, ReactiveFormsModule,
    ButtonModule, InputTextModule
  ],
  templateUrl: './dynamic-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormV2Component {
  readonly form = input<any>(null);
  readonly closeButton = input(false);
  readonly actionText = input<string>('');
  readonly model = input<any>({});

  readonly formValue = output<any>();

  // Internal FormGroup for formly
  readonly dynamicForm = new FormGroup({});
  fields: FormlyFieldConfig[];

  onSubmit() {
    this.formValue.emit(this.model());
  }

  onClose() {
    this.formValue.emit(undefined);
  }
}
